import { useState } from 'react';
import { setLocale, type Locale } from '@/i18n';
import { Icon } from '@/design-system/icons/Icon';

const LABELS: Record<Locale, string> = {
  'pt-BR': '🇧🇷 Português (BR)',
  'pt-PT': '🇵🇹 Português (PT)',
};

export const LocaleSwitcher = () => {
  const [current, setCurrent] = useState<Locale>(() => {
    if (typeof localStorage !== 'undefined') {
      const stored = localStorage.getItem('canapyra-locale');
      if (stored === 'pt-BR' || stored === 'pt-PT') return stored;
    }
    return 'pt-BR';
  });

  const pick = (locale: Locale) => {
    setLocale(locale);
    setCurrent(locale);
    window.location.reload();
  };

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      <Icon name="globe" size={14} />
      <select
        value={current}
        onChange={(e) => pick(e.target.value as Locale)}
        style={{
          background: 'transparent',
          border: '1px solid var(--line)',
          borderRadius: 'var(--r-2)',
          padding: '4px 8px',
          fontSize: 13,
        }}
      >
        {(['pt-BR', 'pt-PT'] as Locale[]).map((l) => (
          <option key={l} value={l}>
            {LABELS[l]}
          </option>
        ))}
      </select>
    </div>
  );
};
